﻿export enum AppType {
    App = "app",
    Standalone = "standalone",
    SharedComponents = "sharedcomponents",
}

export function parseAppType(appType: string | undefined): AppType {
    const normalized = appType?.toLowerCase() as AppType;
    return Object.values(AppType).includes(normalized) ? normalized : AppType.App;
}
